
import React from 'react'

import HeaderSubmenuItem from './HeaderSubmenuItem'

import './HeaderSubMenu.scss'

interface Props {
  submenu: any
  secondarySubmenu?: any
  projectName?: string
}

const HeaderSubMenu = ({ submenu, secondarySubmenu = [], projectName }: Props) => {

  return (
    <>
      <div className="horizontal-bar-wrap">
        <div className="header-topnav">
          <div className="submenu-bar">
            {submenu.length > 0 && (
              <div className="submenu-left">
                <ul className="submenu submenu-primary">
                  {submenu.map((item: any, i: number) => (
                    <HeaderSubmenuItem
                      key={i}
                      active={item.active}
                      disabled={item.disabled}
                      icon={item.icon}
                      text={item.text}
                      path={item.path}
                      itemWidth={item.itemWidth}
                    />
                  ))}
                </ul>
                {secondarySubmenu.length > 0 && (
                  <ul className="submenu submenu-secondary">
                    {secondarySubmenu.map((item: any, i: number) => (
                      <HeaderSubmenuItem
                        key={i}
                        active={item.active}
                        disabled={item.disabled}
                        icon={item.icon}
                        text={item.text}
                        path={item.path}
                        itemWidth={item.itemWidth}
                      />
                    ))}
                  </ul>
                )}
              </div>
            )}
            <div className="submenu-right">
              {projectName && (
                <div className={`subtitle${''}`}>
                  {projectName}
                </div>
              )}
              <div className="header-dropdowns" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HeaderSubMenu
